// extracted by mini-css-extract-plugin
export default {"row":"style_row__fQADV","grid":"style_grid__gCVWZ"};